import React, { useState, useEffect, useContext } from 'react';
import { Container, Header, BarChart, Select } from '@amzn/awsui-components-react-v3';
import { StateContext, DispatchContext } from './context/spotcp-context';
import { getJSClient } from '../js_client';
import { SPOTCP_HCP_COMPONENT_OPTIONS, STATUS_FINISHED, STATUS_LOADING, SHIPMENT_BAR_CHART_ID } from './elements';
import '../../styles/spotcp.css';
import { SpotcpAsinHistogramInfo, InfoLink } from './info';
import logger from '../../utils/logging';
import ContextMenu from './custom/context-menu';

const componentOptions = [{ label: 'Net CP', id: 'total' }].concat(SPOTCP_HCP_COMPONENT_OPTIONS);

export const HistogramShipments = (props) => {
  let client;

  const { histogramData, request } = useContext(StateContext);
  const dispatch = useContext(DispatchContext);

  const [selectedComponent, setSelectedComponent] = useState(componentOptions[0]);
  const [barchartData, setBarchartData] = useState([]);
  const [xDomain, setXDomain] = useState([]);
  const [chartStatus, setChartStatus] = useState([STATUS_LOADING]);
  const [visibleSeries, setVisibleSeries] = useState([]);

  // effect
  useEffect(() => {
    client = getJSClient();
  });

  useEffect(() => {
    getBarchartData(selectedComponent.id);
  }, [histogramData]);

  // helper
  const generateData = (input, title) => {
    return {
      title,
      type: 'bar',
      data: input.map((d) => ({
        x: d.binName,
        y: Math.round(d.value * 10000) / 100,
      })),
      valueFormatter: (t) => t.toLocaleString('en-US') + '%',
    };
  };
  const getBarchartData = (componentId) => {
    setChartStatus(STATUS_LOADING);
    if (histogramData) {
      let shipmentDataFA = histogramData[`${componentId}|shipment|fa`];
      let asinDataFA = histogramData[`${componentId}|asin|fa`];

      let shipmentDataLA = histogramData[`${componentId}|shipment|la`];
      let asinDataLA = histogramData[`${componentId}|asin|la`];
      if (!shipmentDataFA && !asinDataFA && !shipmentDataLA && !asinDataLA) {
        // no data available, then query runSpotcpAsinHistogram api to get both FA and LA
        client.runSpotcpAsinHistogramFaAndLa(dispatch, { ...request, component: componentId });
      } else if (shipmentDataFA && asinDataFA && !shipmentDataLA && !asinDataLA) {
        logger.info('Histograme data query for LA is still running....');
      } else if (!shipmentDataFA && !asinDataFA && shipmentDataLA && asinDataLA) {
        logger.info('Histograme data query for FA is still running....');
      } else if (shipmentDataFA && asinDataFA && shipmentDataLA && asinDataLA) {
        setXDomain(shipmentDataFA.map((d) => d.binName));
        let newBarchartData = [
          generateData(shipmentDataFA, 'Shipment% (FA)'),
          generateData(shipmentDataLA, 'Shipment% (LA)'),
          generateData(asinDataFA, 'Asin% (FA)'),
          generateData(asinDataLA, 'Asin% (LA)'),
        ];
        setBarchartData(newBarchartData);
        setVisibleSeries(newBarchartData);
        setChartStatus(STATUS_FINISHED);
      } else {
        logger.debug('backend return weird partial data for shipment/asin histogram.', histogramData);
      }
    }
  };

  const onSelectChanged = (e) => {
    setSelectedComponent(e.detail.selectedOption);
    getBarchartData(e.detail.selectedOption.id);
  };

  return (
    <Container
      className="custom-dashboard-container"
      header={
        <Header
          variant="h2"
          description="Net variances vs. Shipment & ASIN %"
          info={<InfoLink onFollow={() => props.updateTools(<SpotcpAsinHistogramInfo />)} />}
          actions={
            <Select
              selectedOption={selectedComponent}
              options={componentOptions}
              onChange={onSelectChanged}
              filteringType="auto"
              className="spotcp-select"
            />
          }
        >
          ASIN Histogram
        </Header>
      }
    >
      <BarChart
        id={`${SHIPMENT_BAR_CHART_ID}`}
        series={barchartData}
        xDomain={xDomain}
        yDomain={[0, 100]}
        i18nStrings={{
          filterPlaceholder: 'Filter data',
          yTickFormatter: (t) => t + '%',
        }}
        errorText="Error loading data."
        height={300}
        loadingText="Loading chart"
        statusType={`${chartStatus}`}
        xScaleType="categorical"
        xTitle={`Net Variances of ${selectedComponent.label}`}
        yTitle="%"
        visibleSeries={visibleSeries}
        onFilterChange={({ detail }) => setVisibleSeries(detail.visibleSeries)}
      />
      <ContextMenu chartID={SHIPMENT_BAR_CHART_ID} selectedComponentID={selectedComponent.id} asinAnalysisRef={props.asinAnalysisRef}/>
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/components/spotcp/histogram-shipments.jsx